import { useTheme } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { mockDataInvoices } from "../../../../data/mockData";
import { DataGridTopHeader } from "../../../../components/styled";
import { InvoiceTableColumns } from "../../../../data/mockTableColumns";
import DashboardLayout from "../../../../components/global/DashboardLayout";
import DashboardHeader from "../../../../components/global/DashboardHeader";

const Contacts = () => {
  const theme = useTheme();

  return (
    <DashboardLayout>
      {/* HEADER */}
      <DashboardHeader
        title="Contacts"
        subtitle="List of All Contacts Profile"
      />

      <DataGridTopHeader theme={theme}>
        <DataGrid
          rows={mockDataInvoices}
          columns={InvoiceTableColumns}
          checkboxSelection
          disableRowSelectionOnClick
          pageSizeOptions={[10, 20, 30]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          slots={{
            toolbar: GridToolbar,
          }}
        />
      </DataGridTopHeader>
    </DashboardLayout>
  );
};

export default Contacts;
